const FETCH_CASES = 'fetch_cases';
const FETCH_CASES_SIMPLY = 'fetch_cases_simply';
const FETCH_CASES_ANOTHER = 'fetch_cases_another';
const FETCH_CASE = 'fetch_case';
const CREATE_STATEMENT = 'create_statement';
const FETCH_STATEMENT_DOCS = 'fetch_statement_docs';
const DELETE_CASE = 'delete_case';
const PERSIST_CASE = 'persist_case';
const CREATE_FILES_CASE = 'create_files_case';
const DELETE_FILE_CASE = 'delete_file_case';
const UPDATE_CASE = 'update_case';
const FETCH_FILES_CASE = 'fetch_files_case';
const CASE_NUMBERS = 'fetch_case_numbers';
const CASE_NUMBERS_STUDENT = 'fetch_case_numbers_student';

const FETCH_CHECK_CASES = 'fetch_check_cases';

export default {
    FETCH_CASES,
    FETCH_CASES_SIMPLY,
    FETCH_CASE,
    UPDATE_CASE,
    DELETE_CASE,
    CASE_NUMBERS_STUDENT,
    CASE_NUMBERS,
    CREATE_STATEMENT,
    FETCH_STATEMENT_DOCS,
    PERSIST_CASE,
    FETCH_FILES_CASE,
    FETCH_CASES_ANOTHER,
    DELETE_FILE_CASE,
    CREATE_FILES_CASE,
    FETCH_CHECK_CASES
};
